import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seoHead";
import ComoGeramos from "@/pages/ComoGeramos";

export const Route = createFileRoute("/como-geramos")({
  head: () => seoHead({
    title: "Como geramos receita | Shopping do Bem",
    description: "Transparência total: entenda como o Shopping do Bem gera receita com comissões de afiliados, o programa Marca do Bem e publicidade — e como cada real é distribuído.",
    path: "/como-geramos",
  }),
  component: ComoGeramos,
});
